import { Typography } from "antd";
import React, { memo } from "react";

const ValidateError = ({ error }) =>
  error && <Typography.Text className="text-nn py-1">*{error}</Typography.Text>;

export default memo(ValidateError);
